import { NavLink } from "react-router";
import classNames from "classnames";
import { Division, Flex, Icon, Icons, Paragraph } from "@ir/ui";
import { CONFIG_NAV_CATEGORIES } from "../configNav.config";
import { useConfigBrand } from "../ConfigBrandContext";

export const ConfigSubNav = () => {
  const { organizationKey, brandKey } = useConfigBrand();

  if (!organizationKey || !brandKey) {
    return null;
  }

  const basePath = `/configuration/${organizationKey}/${brandKey}`;

  return (
    <nav className="config-subnav" aria-label="Configuration categories">
      {CONFIG_NAV_CATEGORIES.map((category) => (
        <Division key={category.key} className="config-subnav__category">
          <Paragraph className="config-subnav__category-label m-0">
            {category.label}
          </Paragraph>
          <Division className="config-subnav__list">
            {category.items.map((item) => (
              <NavLink
                key={item.key}
                to={`${basePath}/${item.section}`}
                className={({ isActive }) =>
                  classNames("config-subnav__item", {
                    "config-subnav__item--active": isActive,
                  })
                }
              >
                <Flex
                  align="center"
                  justifyContent="space-between"
                  className="w-100"
                  gap={0.5}
                >
                  <Paragraph className="config-subnav__title m-0 text-sm">
                    {item.label}
                  </Paragraph>
                  <Icon
                    name={Icons.ChevronRight}
                    className="config-subnav__chevron"
                  />
                </Flex>
              </NavLink>
            ))}
          </Division>
        </Division>
      ))}
    </nav>
  );
};
